import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { Link, browserHistory } from 'react-router';
import BlogPosts from 'swag-client-common/components/info/blog-posts';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import swagWhiteImage from 'assets/svg/swag-white.svg';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { scrollToItem } from 'swag-client-common/utils/tricks';
import classes from './footer-main.scss';
import { tastyLinks, swagLinks, informationLinks } from './footer-main.constants';
const NOTICE_TO_CALIFORNIA_CONSUMERS_ANCHOR = 'notice-to-california-consumers';
const DO_NOT_SELL_MY_PERSONAL_INFO_LINK = `${APP_ROUTES.PRIVACY_POLICY}#${NOTICE_TO_CALIFORNIA_CONSUMERS_ANCHOR}`;
const CUSTOM_INK_LINK = 'https://www.customink.com/';
export const FooterMain = ({
  footerClassName = '',
  isRedirectDisabled
}) => {
  const handleLinkClick = (e, link, isDefaultBehavior) => {
    if (isDefaultBehavior || isRedirectDisabled) {
      return;
    }
    e.preventDefault();
    browserHistory.push(link);
  };
  const handleClickDoNotSellMyPersonalInfo = event => {
    event.preventDefault();
    if (window.location.pathname === APP_ROUTES.PRIVACY_POLICY) {
      scrollToItem(NOTICE_TO_CALIFORNIA_CONSUMERS_ANCHOR, {
        behavior: 'auto',
        yOffset: -30
      });
      return;
    }
    handleLinkClick(event, DO_NOT_SELL_MY_PERSONAL_INFO_LINK);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.footer, footerClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(AnimationWrapper, {
    offset: 100
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.grid
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.swagLogoContainer
  }, /*#__PURE__*/React.createElement(Link, {
    className: classes.img,
    to: APP_ROUTES.HOME
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.logo,
    alt: "Swag",
    src: swagWhiteImage
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.footCol100
  }, /*#__PURE__*/React.createElement("h4", {
    className: classes.header
  }, "we made this."), /*#__PURE__*/React.createElement("div", {
    className: classes.p
  }, "Custom promo products that people actually want to keep."), /*#__PURE__*/React.createElement("div", {
    className: classes.p
  }, "We help companies create custom promotional products that make your brand stand out. Custom Logo products, bulk promotional merchandise, gift giveaways and items that we know you\u2019ll love."), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.p, classes.tosLink)
  }, /*#__PURE__*/React.createElement("a", {
    className: classNames(classes.link, classes.smallText),
    href: DO_NOT_SELL_MY_PERSONAL_INFO_LINK,
    onClick: e => handleClickDoNotSellMyPersonalInfo(e)
  }, "Do Not Sell My Personal Information")), /*#__PURE__*/React.createElement("div", {
    className: classes.p
  }, "\xA9 2016-", moment().year(), " Swag.com. A", ' ', /*#__PURE__*/React.createElement("a", {
    className: classes.lineLink,
    href: CUSTOM_INK_LINK,
    target: "_blank",
    rel: "noreferrer"
  }, "Custom Ink"), ' ', "Company.", /*#__PURE__*/React.createElement("br", null), "All Rights Reserved."))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.grid, classes.tabletRow)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.latestNewsColumn
  }, /*#__PURE__*/React.createElement("h5", {
    className: classes.caption
  }, "Latest News"), /*#__PURE__*/React.createElement(BlogPosts, {
    ulClassName: classes.ul,
    liClassName: classes.li,
    linkClassName: classes.link
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.tastyLinksColumn
  }, /*#__PURE__*/React.createElement("h5", {
    className: classes.caption
  }, "Tasty links"), /*#__PURE__*/React.createElement("ul", {
    className: classes.ul,
    "data-list": "TastyLinks"
  }, tastyLinks.map(({
    label,
    link
  }) => /*#__PURE__*/React.createElement("li", {
    className: classes.li,
    key: link
  }, /*#__PURE__*/React.createElement("a", {
    className: classes.link,
    href: link,
    onClick: e => handleLinkClick(e, link)
  }, label))))), /*#__PURE__*/React.createElement("div", {
    className: classes.swagColumn
  }, /*#__PURE__*/React.createElement("h5", {
    className: classes.caption
  }, "Swag"), /*#__PURE__*/React.createElement("ul", {
    className: classes.ul,
    "data-list": "Swag"
  }, swagLinks.map(({
    label,
    link,
    rel,
    target,
    isDefaultBehavior
  }) => /*#__PURE__*/React.createElement("li", {
    className: classes.li,
    key: link
  }, /*#__PURE__*/React.createElement("a", {
    className: classes.link,
    href: link,
    onClick: e => handleLinkClick(e, link, isDefaultBehavior),
    rel: rel,
    target: target || '_self'
  }, label))))), /*#__PURE__*/React.createElement("div", {
    className: classes.informationColumn
  }, /*#__PURE__*/React.createElement("h5", {
    className: classes.caption
  }, "Information"), /*#__PURE__*/React.createElement("ul", {
    className: classes.ul,
    "data-list": "Swag"
  }, informationLinks.map(({
    label,
    link = '#',
    rel,
    target,
    isDefaultBehavior
  }) => /*#__PURE__*/React.createElement("li", {
    className: classes.li,
    key: link
  }, /*#__PURE__*/React.createElement("a", {
    className: classes.link,
    onClick: e => handleLinkClick(e, link, isDefaultBehavior),
    href: link,
    rel: rel,
    target: target || '_self'
  }, label)))), /*#__PURE__*/React.createElement("div", {
    className: classes.mobRights
  }, "\xA9 2016-", moment().year(), " Swag.com. A", ' ', /*#__PURE__*/React.createElement("a", {
    className: classes.lineLink,
    href: CUSTOM_INK_LINK,
    target: "_blank",
    rel: "noreferrer"
  }, "Custom Ink"), ' ', "Company."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: classes.rightsReservedLine
  }, "All Rights Reserved."))))))));
};